import {
  ServiceProviderCategoryEnum,
  ServiceProvisionTypeEnum,
} from '../../../../../lib/graphql'
import { ImageWithFallBack } from '../../../../../types'
import { MAPPED_STANDARD_SERVICE_PROVIDER_ICONS } from '../../../../organisms/proposal/service-provider.constant'

type ComputeServiceProvisionsProps = {
  serviceProviderCategory: ServiceProviderCategoryEnum
  type: ServiceProvisionTypeEnum
  serviceProviderId?: string | null
}
export const getServiceProvisionTypeImage = ({
  serviceProviderId,
  serviceProviderCategory,
  type,
}: ComputeServiceProvisionsProps): ImageWithFallBack => {
  const BASE_FOLDER = serviceProviderCategory
    ? `/images/service-provisions/${serviceProviderCategory.toLocaleLowerCase()}/`
    : ''

  const BASE_MIME_TYPE = '.png'

  const fallBackSrc = `${BASE_FOLDER}PLACEHOLDER${BASE_MIME_TYPE}`

  /**
   * If the ServiceProviderCategory is an ACTIVITY :
   * - The image is either Image or Image_ALT
   * If the ServiceProviderCategory is a RESTAURATION :
   * - If the serviceProviderId is defined, the image is Image_{RandomNumber[1-5]}
   * - If the serviceProviderId is not defined, the image is either Image or Image_ALT
   */

  let imageFolder = ''
  let imageOrAlt = ''

  if (serviceProviderCategory === ServiceProviderCategoryEnum.ACTIVITY) {
    imageFolder = `${BASE_FOLDER}${type}/`
    imageOrAlt = `${type}${Math.random() < 0.5 ? '' : '_ALT'}`
  } else if (
    serviceProviderCategory === ServiceProviderCategoryEnum.RESTAURATION
  ) {
    let folder = ''

    if (serviceProviderId) {
      folder =
        MAPPED_STANDARD_SERVICE_PROVIDER_ICONS[serviceProviderId]?.toUpperCase()
      imageOrAlt = `${folder}_${Math.floor(Math.random() * 5) + 1}`
    } else {
      folder = ServiceProvisionTypeEnum.OTHER
      imageOrAlt = `${folder}${Math.random() < 0.5 ? '' : '_ALT'}`
    }

    imageFolder = `${BASE_FOLDER}${folder}/`
  }

  const src = `${imageFolder}${imageOrAlt}${BASE_MIME_TYPE}`

  return { image: { fallBackSrc, src } }
}
